module.exports = __webpack_public_path__ + "static/media/pic3.00148b2d.JPG";